import axios from '@!/lib/axios'
import { buildUrlString } from '@!/Util'

export const getTopFeaturesApi = async (safeSearch, genreName, page) => {
  const params = {
    safe_search: safeSearch,
    page: page,
  }

  if (genreName) {
    params.genre_name = genreName
  }

  const url = buildUrlString('/api/v1/features/top', params)

  return await axios.get(url)
}
